import { FieldType } from '@/components/Form';
import { DatabaseField, FilterInputProps } from '@/modules/corporate/modules/database/fields/types';

import SelectFieldEditorConfig from '../select/Editor/config';
import SelectFilterInput from '../select/FilterInput';
import { adaptSelectField, isFormDataValid } from '../select/utils';
import Cell from './Cell';
import { MultiSelectFieldStaticConfig } from './config';
import EditableCell from './EditableCell';
import MultiSelectOperators from './operators';
import { adaptFormData, adaptFormField, parseFormData } from './utils';

const MultiSelectField: DatabaseField = {
  ...MultiSelectFieldStaticConfig,
  Table: {
    Cell,
    EditableCell,
    FilterInput: (props: Omit<FilterInputProps, 'multiple'>) => (
      <SelectFilterInput multiple {...props} />
    ),
    operators: MultiSelectOperators,
  },
  Viewer: {
    adaptFormData,
    adaptFormField,
    isFormDataValid,
    parseFormData,
    fieldType: FieldType.MultiPicklist,
  },
  Editor: SelectFieldEditorConfig,
  adaptField: adaptSelectField,
};

export default MultiSelectField;
